import { replaceDoubleSpaceToSingle } from "utils";
import { calculateTotalFee } from '../../../../utils';
import { submitApplication } from '../../../../utilities';
import setLoading from "components/loading";

export default {
  'ModalBody.Container.AgreeSection.Field.Name': ({ value }, stateManager) => {
    stateManager.setLeaseholderName(replaceDoubleSpaceToSingle(value));
  },
  'ModalBody.Container.AgreeSection.Field.Button': ({ property, occupants, value, disabled, isAdminFeePaid }, stateManager) => {
    if(disabled) return
    const amount = calculateTotalFee(property, occupants, isAdminFeePaid)
    if (amount > 0) {
      stateManager.setTermsAccepted(true)
      stateManager.setTermsModal(false);
    } else {
      setLoading(true)
      submitApplication(stateManager, null, property).then(() => {
        stateManager.setTermsModal(false);
      })
    }

  }
}
